module.exports = __webpack_public_path__ + "static/media/uel_logo.fb0d1dec.png";